import { Reducer } from 'redux';

import { BrowserStorageService } from '@/services/BrowserStorage';
import { UserActionTypes } from '@/store/reducers/user/action-types';

import { GlobalActionTypes } from './action-types';
import { initialState } from './constants';
import { GlobalReducerState as State } from './types';

export const globalReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case GlobalActionTypes.SET_GLOBAL_ERROR:
      return { ...state, error: action.payload };

    case GlobalActionTypes.CLEAR_GLOBAL_ERROR:
      return { ...state, error: null };

    case GlobalActionTypes.TRAINING_REQUIRED_MODAL.OPEN:
      return {
        ...state,
        trainingRequiredModal: {
          ...state.trainingRequiredModal,
          isOpened: true,
          onCloseCallback: action.payload.onCloseCallback,
        },
      };

    case GlobalActionTypes.TRAINING_REQUIRED_MODAL.CLOSE:
      return { ...state, trainingRequiredModal: initialState.trainingRequiredModal };

    case GlobalActionTypes.SUBMIT_ORDER_MODAL.OPEN:
      return {
        ...state,
        submitOrderModal: {
          ...state.submitOrderModal,
          isOpened: true,
          opportunityId: action.payload.opportunityId,
          updateDetails: action.payload.updateDetails || false,
        },
      };

    case GlobalActionTypes.SUBMIT_ORDER_MODAL.CLOSE:
      return { ...state, submitOrderModal: initialState.submitOrderModal };

    case UserActionTypes.FETCH_USER_INFO.SUCCESS: {
      if (
        BrowserStorageService.leadsPassingProgram.get() ||
        action.payload.companyInfo.isLeadsPassingEligible
      ) {
        return state;
      }

      return {
        ...state,
        acceptLeadsPassingModal: {
          ...state.acceptLeadsPassingModal,
          isOpened: true,
          companyId: action.payload.companyInfo.id,
        },
      };
    }

    case UserActionTypes.ACCEPT_LEADS_PASSING_PROGRAM.SUCCESS:
    case GlobalActionTypes.ACCEPT_LEADS_PASSING_MODAL.CLOSE:
      BrowserStorageService.leadsPassingProgram.set();

      return { ...state, acceptLeadsPassingModal: initialState.acceptLeadsPassingModal };

    default:
      return state;
  }
};
